import Footer from "../components/footer"
import Menu from "../components/menu"
import PremiumSection from "../components/premiumSection"

const Premium: React.FC = () => {
    return(
        <><Menu />
        <PremiumSection />
        <Footer />
        </>
    
    );
}

export default Premium;